import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

interface SupplierLocationCardBadgeProps {
  hasInstantApproval: boolean;
}

const SupplierLocationCardBadge = ({ hasInstantApproval }: SupplierLocationCardBadgeProps) => {
  const theme = useTheme();
  const label = hasInstantApproval ? 'Instant Approval' : 'Request Space';
  const severity = hasInstantApproval ? 'success' : 'warning';

  return (
    <Box
      sx={{
        position: 'absolute',
        top: '0.5rem',
        left: '0.5rem',
        zIndex: 1,
        background: theme.palette[severity].main,
        borderRadius: '0.2857em',
        padding: '0.2857em 0.5714em',
        width: 'fit-content',
      }}
    >
      <Typography
        sx={{
          color: 'white',
          textTransform: 'uppercase',
          fontSize: '.7143rem',
          fontFamily: 'Inter',
          fontStyle: 'normal',
          fontWeight: 500,
          lineHeight: '1rem',
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};

export default SupplierLocationCardBadge;
